//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import ROLES from '@/constants/roles'
import { MESSAGE_TYPE } from '~/constants/core'
import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar'

export default {
  components: {
    ValidationObserver,
    ModalWithTitleBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    roleType: {
      type: String,
      default: ROLES.EMPLOYEE,
    },
    emailTemplate: {
      type: String,
      default: '',
    },
    userIds: {
      type: Array,
      default: () => [],
    },
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        message: '',
      },
      confirmedModal: false,
      isLoading: false,
    }
  },
  methods: {
    clean() {
      this.form.message = ''
    },
    toggleModalResendMassive() {
      this.clean()
      this.$emit('close')
    },
    closeConfirmedModal() {
      this.confirmedModal = !this.confirmedModal
    },
    async preview() {
      const customMessage = this.form.message
      const companyName = this.$repository.me.getMe().company?.name

      const response = await this.$repository.invitation.previewCollaboratorEmployeeReminderInvitationMail(
        {
          companyName,
          projectName: this.project.name,
          customMessage,
        }
      )
      window.open(response.url, '_blank')
    },
    async submit() {
      this.isLoading = true
      try {
        await this.$repository.invitation.collaboratorEmployeeProgressQuestionaryReminderInvitation(
          {
            usersIds: this.userIds,
            projectId: this.project.id,
            customMessage: this.form.message,
          }
        )
        this.confirmedModal = true
      } catch (e) {
        const message = e.response.data.map(
          (e) => `
            Ocurrió un error con la invitación ${e.id} de ${
            e.email ? e.email : ''
          }: ${e.error}
          `
        )
        await this.$store.dispatch('core/showMessage', {
          message,
          type: MESSAGE_TYPE.DANGER,
        })
      }
      this.isLoading = false
      this.clean()
      this.$emit('confirmed')
    },
  },
}
